export default {
  blog: () => import("/var/www/html/layouts/blog.vue").then(m => m.default || m),
  default: () => import("/var/www/html/layouts/default.vue").then(m => m.default || m),
  page: () => import("/var/www/html/layouts/page.vue").then(m => m.default || m),
  raw: () => import("/var/www/html/layouts/raw.vue").then(m => m.default || m),
  rec: () => import("/var/www/html/layouts/rec.vue").then(m => m.default || m),
  spa: () => import("/var/www/html/layouts/spa.vue").then(m => m.default || m)
}